<div class="container">
  <div class="wrapper">
    <div class="div-seccion">
      <!-- secciones-->
      <div class="div-main-content">
        <router-outlet></router-outlet>
      </div>
      <!-- Seccion nav-stepper -->
      <div class="title-section nav-div">
        <app-tramite-pension-stepper></app-tramite-pension-stepper>
      </div>
    </div>
  </div>
</div>
